import React from 'react'
import { NumberInput, TextInput } from 'react-admin'
import { MainIntoleranceType } from 'services/api/entities/events/types/internal/selections'
import KAccordion from 'ui-shared/accordions/KAccordion'

type Props = {
  source: string
  disabled?: boolean
}

const INTOLERANCES: MainIntoleranceType[] = [
  'gluten',
  'lactose',
  'vegetarian',
  'vegan',
]

const IntolerancesInput: React.FC<Props> = ({ source, disabled = false }) => {
  return (
    <KAccordion accordionTitle="Intolerances">
      {INTOLERANCES.map((intolerance, i) => (
        <NumberInput
          key={i}
          source={`${source}.${intolerance}`}
          label={`form.fields.intolerances.${intolerance}`}
          disabled={disabled}
          style={{ width: '24%', marginRight: '8px' }}
          min={0}
        />
      ))}
      <TextInput
        source={`${source}.other`}
        label="form.fields.intolerances.other"
        disabled={disabled}
        style={{ width: '100%', marginTop: '8px' }}
      />
    </KAccordion>
  )
}

export default IntolerancesInput
